import { intentStatusSchema } from "@redotech/redo-model/checkouts/predictive-conversion-settings";
import * as z from "zod";

export const getIntentStatus = {
  name: "getIntentStatus" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ intentStatus: intentStatusSchema }),
};
